import { FormAdicionarNumeros } from "../components/admin/NumerosPersonalizar/modal-adicionar-numeros";
import { FormAdicionarComboRoleta } from "../components/admin/roleta-instantanea/modal-combo-adicionar-premio";
import { FormAdicionarPremioRoleta } from "../components/admin/roleta-instantanea/modal-roleta-adicionar-premio";
import { BotoesNumerosRifasType } from "../types/BotoesNumerosRifas";
import { getAPIClient } from "./axios";

const api = getAPIClient();

export const useApi = () => ({
  autorizaToken: (token: string) => {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  },
  validarToken: async () => {
    const resposta = await api.post("/auth/validar");
    return resposta.data;
  },
  buscarNumeros: async (id: number) => {
    const resposta = await api.get(`/pedidos/buscar-numeros/${id}`);
    return resposta.data;
  },

  login: async (email: string, senha: string) => {
    const resposta = await api.post("/auth/login", { email, senha });
    return resposta.data;
  },
  verifyTwoFactor: async (email: string, code: string) => {
    try {
      const response = await api.post(`/verificar-codigo`, { email, code });
      return response.data;
    } catch (error) {
      return { erro: "Erro de conexão" };
    }
  },
  resendTwoFactorCode: async (email: string) => {
    try {
      const response = await api.post(`/reenviar-codigo`, { email });
      return response.data;
    } catch (error) {
      return { erro: "Erro de conexão" };
    }
  },
  cadastro: async (data: object) => {
    const resposta = await api.post("/auth/cadastrar", data);
    return resposta.data;
  },
  atualizarUsuario: async (data: object) => {
    const resposta = await api.post("/usuario/atualizar-usuario", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resposta.data;
  },
  logout: async () => {
    const resposta = await api.post("/auth/logout");
    return resposta.data;
  },
  atualizarSenha: async (data: object) => {
    const resposta = await api.post("/auth/atualizar-senha", data);
    return resposta.data;
  },
  buscaRifas: async (paramentros: object) => {
    const resposta = await api.get("/rifa/buscar-rifas", {
      params: paramentros,
    });
    return resposta.data;
  },
  buscaUsuarios: async (nomeusuario: string) => {
    const resposta = await api.get(`/buscar-usuario/${nomeusuario}`);
    return resposta.data;
  },
  buscaRifa: async (id: any) => {
    const resposta = await api.get(`/rifa/${id}`);
    return resposta.data;
  },
  buscaRifaPorUsuario: async (paramentros?: object) => {
    const resposta = await api.get(`/rifas`, { params: paramentros });
    return resposta.data;
  },
  buscaPremioRifa: async (id: number) => {
    const resposta = await api.get(`/rifa/${id}/buscar-premios-rifa`);
    return resposta.data;
  },
  buscaPromocaoRifa: async (id: number) => {
    const resposta = await api.get(`/rifa/${id}/buscar-promocao-rifa`);
    return resposta.data;
  },
  buscaNumerosReservados: async (id: number) => {
    const resposta = await api.get(`/rifa/${id}/buscar-numeros-status`);
    return resposta.data;
  },
  reservarNumeros: async (data: object, id: number) => {
    const resposta = await api.post(`/rifa/${id}/reservar-numeros/`, data);
    return resposta.data;
  },
  buscaDadosReserva: async (id: string | string[]) => {
    const resposta = await api.get(`/reserva/${id}/buscar-dados-reserva`);
    return resposta.data;
  },
  buscarNumerosPedidoCelular: async (rifaId: number, data: object) => {
    const resposta = await api.get(`/buscar-numeros-pedido-celular/${rifaId}`, {
      params: data,
    });
    return resposta.data;
  },
  buscaCategoriaRifa: async () => {
    const resposta = await api.get(`/buscar-categoria-rifa`);
    return resposta.data;
  },
  cadastrarRifa: async (data: object) => {
    const resposta = await api.post("/rifa/inserir-rifa", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resposta.data;
  },
  atualizarRifa: async (id: number, data: object) => {
    const resposta = await api.put(`/rifa/${id}/atualizar-rifa`, data);
    return resposta.data;
  },
  adicionarImagem: async (id: number, data: object) => {
    const resposta = await api.post(`/rifa/${id}/adicionar-imagem-rifa`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resposta.data;
  },
  adicionarPremio: async (id: number, data: object) => {
    const resposta = await api.post(`/rifa/${id}/adicionar-premio-rifa`, data);
    return resposta.data;
  },
  adicionarPromocao: async (id: number, data: object) => {
    const resposta = await api.post(
      `/rifa/${id}/adicionar-promocao-rifa`,
      data
    );
    return resposta.data;
  },
  deletarImagem: async (id: number) => {
    const resposta = await api.delete(`/rifa/${id}/deletar-imagem`);
    return resposta.data;
  },
  deletarPremio: async (idRifa: number, idPremio: number) => {
    const resposta = await api.delete(
      `/rifa/${idRifa}/deletar-premio/${idPremio}`
    );
    return resposta.data;
  },
  deletarPromocao: async (id: number) => {
    const resposta = await api.delete(`/rifa/${id}/deletar-promocao`);
    return resposta.data;
  },
  buscaPedidos: async (params: object) => {
    const resposta = await api.get(`/pedidos/`, { params: params });
    return resposta.data;
  },
  finalizarRifa: async (id: number, data: object) => {
    const resposta = await api.post(`/rifa/${id}/finalizar-rifa`, data);
    return resposta.data;
  },
  finalizarRifaOutro: async (id: number, data: object) => {
    const resposta = await api.post(`/rifa/${id}/finalizar-rifa-outros`, data);
    return resposta.data;
  },
  finalizarRifaAleatoria: async (id: number) => {
    const resposta = await api.post(`/rifa/${id}/finalizar-rifa-aleatoria`);
    return resposta.data;
  },
  geraCobrancaPix: async (data: object) => {
    const resposta = await api.post(`mercado-pago/gerar-cobranca-pix`, data);
    return resposta.data;
  },
  geraQrcodePixManual: async (data: object) => {
    const resposta = await api.post(`pedido/gerar-qrcode-pix`, data);
    return resposta.data;
  },
  buscarQrCodePixRifa: async (id: string) => {
    const resposta = await api.get(`gerencianet/buscar-qrcode-pix/${id}`);
    return resposta.data;
  },
  geraQrCodePixRifa: async (data: object) => {
    const resposta = await api.post(`/mercado-pago/gerar-qrcode-pix`, data);
    return resposta.data;
  },
  geraQrCodePixRifaGerencia: async (data: object) => {
    const resposta = await api.post(`/gerencianet/gerar-cobranca-pix`, data);
    return resposta.data;
  },
  buscarPagamento: async (id: string) => {
    const resposta = await api.get(`/mercado-pago/buscar-pagamento/${id}`);
    return resposta.data;
  },
  buscarPagamentoPedido: async (id: number) => {
    const resposta = await api.get(
      `/mercado-pago/buscar-pagamento-pedido/${id}`
    );
    return resposta.data;
  },
  alterarPedido: async (id: string, status: string) => {
    const resposta = await api.post(`/pedidos/alterar-pedido/${id}/${status}`);
    return resposta.data;
  },
  atualizarAccessToken: async (data: object) => {
    const resposta = await api.post(
      "/mercado-pago/atualizar-accesstoken",
      data
    );
    return resposta.data;
  },
  buscarMaioresCompradores: async (id: number, filtro: object) => {
    const resposta = await api.get(
      `/pedidos/buscar-maiores-compradores/${id}`,
      { params: filtro }
    );
    return resposta.data;
  },
  buscaTotalPedidosPorRifa: async (id: number) => {
    const resposta = await api.get(`/pedidos/total-pedidos/${id}`);
    return resposta.data;
  },
  atualizarPix: async (data: object) => {
    const resposta = await api.post("/usuario/inserir-pix", data);
    return resposta.data;
  },
  recuperarSenha: async (email: string) => {
    const resposta = await api.post(`/recuperar-senha/${email}`);
    return resposta.data;
  },
  alterarSenha: async (data: object) => {
    const resposta = await api.post("/alterar-senha", data);
    return resposta.data;
  },
  verificarStatusRifa: async (id: number) => {
    const resposta = await api.get(`/rifa/${id}/verificar-status-rifa/`);
    return resposta.data;
  },
  verificarStatusPedido: async (id: number) => {
    const resposta = await api.get(`pedido/${id}/verificar-status-pedidos/`);
    return resposta.data;
  },
  getPersonalizacao: async () => {
    const resposta = await api.get(`personalizar/get-personalizacao`);
    return resposta.data;
  },
  uploadLogo: async (data: object) => {
    const resposta = await api.post(`personalizar/upload-logo`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resposta.data;
  },
  removeLogo: async (id: number | undefined) => {
    const resposta = await api.delete(`/personalizar/remove-logo/${id}`);
    return resposta.data;
  },
  salvarAparencia: async (data: any) => {
    const resposta = await api.post("/personalizar/salvar-aparencia", data);
    return resposta.data;
  },
  salvarSuitPay: async (data: any) => {
    const resposta = await api.post("/suit-pay/salvar", data);
    return resposta.data;
  },
  salvarPagoExpress: async (data: any) => {
    const resposta = await api.post("/pagoexpress/salvar", data);
    return resposta.data;
  },
  salvarEfi: async (data: any) => {
    const resposta = await api.post("/efi/salvar", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resposta.data;
  },
  gerarQrCodeSuitPay: async (data: any) => {
    const resposta = await api.post("/suit-pay/gerar-qrcode", data);
    return resposta.data;
  },
  gerarQrCodeEfi: async (data: any) => {
    const resposta = await api.post("/efi/gerar-qrcode-pix", data);
    return resposta.data;
  },
  gerarQrCodePagoexpress: async (data: any) => {
    const resposta = await api.post("/pagoexpress/gerar-qrcode-pix", data);
    return resposta.data;
  },
  buscarIntegracao: async () => {
    const resposta = await api.get(`integracao/buscar-integracao`);
    return resposta.data;
  },
  salvarIntegracao: async (data: any) => {
    const resposta = await api.post("/integracao/salvar", data);
    return resposta.data;
  },
  atualizarIntegracao: async (id: number, data: any) => {
    const resposta = await api.post(`/integracao/atualizar/${id}`, data);
    return resposta.data;
  },
  removerIntegracao: async (id: number) => {
    const resposta = await api.delete(`/integracao/remover/${id}`);
    return resposta.data;
  },
  getRifasFiltro: async () => {
    const resposta = await api.get(`/rifa/rifas-filtro`);
    return resposta.data;
  },
  gerarNumerosPremiados: async (id: number, data: any) => {
    const resposta = await api.post(
      `/rifa/${id}/gerar-numeros-premiados`,
      data
    );
    return resposta.data;
  },
  adicionarNumeroPremiado: async (id: number, data: any) => {
    const resposta = await api.post(
      `/rifa/${id}/adicionar-numeros-premiados`,
      data
    );
    return resposta.data;
  },
  buscarNumerosPremiados: async (slug: string) => {
    const resposta = await api.get(`/rifa/${slug}/buscar-numeros-premiados`);
    return resposta.data;
  },
  salvarDominio: async (data: any) => {
    const resposta = await api.post(`personalizar/salvar-dominio`, data);
    return resposta.data;
  },
  deletarDominio: async (id: number | undefined) => {
    const resposta = await api.delete(`personalizar/deletar-dominio/${id}`);
    return resposta.data;
  },
  removerNumerosPremiados: async (id: number, idNumeros: number[]) => {
    const resposta = await api.delete(`/rifa/${id}/remover-numeros-premiados`, {
      data: idNumeros,
    });
    return resposta.data;
  },
  adicionarEbook: async (slug: string | undefined, data: FormData) => {
    const resposta = await api.post(`rifa/${slug}/ebook`, data);
    return resposta.data;
  },
  buscarEbooks: async (slug: string | undefined) => {
    const resposta = await api.get(`rifa/${slug}/ebook`);
    return resposta.data;
  },
  habilitarEbook: async (slug: string | undefined, data: object) => {
    const resposta = await api.post(`rifa/${slug}/ebook/habilitar`, data);
    return resposta.data;
  },
  downloadArquivo: async (id: number) => {
    const resposta = await api.get(`ebooks/download/${id}`, {
      responseType: "blob",
    });
    return resposta.data;
  },
  exibeNumerosPremiados: async (slug: string | undefined, data: object) => {
    const resposta = await api.post(
      `rifa/${slug}/exibe-numeros-premiados`,
      data
    );
    return resposta.data;
  },
  buscarBotoesNumeros: async (slug: string) => {
    const resposta = await api.get(`/rifa/${slug}/botoes-numeros`);
    return resposta.data;
  },
  adicionarBotoesNumeros: async (slug: string, data: FormAdicionarNumeros) => {
    const resposta = await api.post(`/rifa/${slug}/botoes-numeros`, data);
    return resposta.data;
  },
  buscarMaiorMenorNumero: async (id: number, data: object) => {
    const resposta = await api.get(`/pedidos/maior-e-menor-numeros/${id}`, {
      params: data,
    });
    return resposta.data;
  },
  downloadPedidos: async (id: number) => {
    const resposta = await api.get(`/pedidos/download/${id}`, {
      responseType: "blob",
    });
    return resposta.data;
  },
  removerBotoesNumeros: async (slug: string, id: number) => {
    const resposta = await api.delete(`/rifa/${slug}/botoes-numeros/${id}`);
    return resposta.data;
  },
  adicionarPremioRoleta: async (
    slug: string,
    data: FormAdicionarPremioRoleta
  ) => {
    const resposta = await api.post(
      `/rifa/${slug}/adicionar-premios-roleta`,
      data
    );
    return resposta.data;
  },
  atualizarPremioRoleta: async (
    slug: string,
    id: number,
    data: FormAdicionarPremioRoleta
  ) => {
    const resposta = await api.put(
      `/rifa/${slug}/atualizar-premios-roleta/${id}`,
      data
    );
    return resposta.data;
  },
  buscarPremiosRoleta: async (slug: string) => {
    const resposta = await api.get(`/rifa/${slug}/buscar-premios-roletas`);
    return resposta.data;
  },
  removerPremioRoleta: async (slug: string, id: number) => {
    const resposta = await api.delete(
      `/rifa/${slug}/remover-premios-roleta/${id}`
    );
    return resposta.data;
  },
  buscarCombosRoleta: async (slug: string) => {
    const resposta = await api.get(`/rifa/${slug}/buscar-combos-roletas`);
    return resposta.data;
  },
  adicionarComboRoleta: async (
    slug: string,
    data: FormAdicionarComboRoleta
  ) => {
    const resposta = await api.post(
      `/rifa/${slug}/adicionar-combos-roleta`,
      data
    );
    return resposta.data;
  },
  atualizarComboRoleta: async (
    slug: string,
    id: number,
    data: FormAdicionarComboRoleta
  ) => {
    const resposta = await api.put(
      `/rifa/${slug}/atualizar-combos-roleta/${id}`,
      data
    );
    return resposta.data;
  },
  removerComboRoleta: async (slug: string, id: number) => {
    const resposta = await api.delete(
      `/rifa/${slug}/remover-combos-roleta/${id}`
    );
    return resposta.data;
  },
  girarRoleta: async (
    rifaId: number,
    pedidoId: number,
    pedidoRoletaId: string
  ) => {
    const resposta = await api.post(
      `rifa/${rifaId}/pedido/${pedidoId}/girar/${pedidoRoletaId}`
    );
    return resposta.data;
  },
  exibePremiosRoletaRifa: async (slug: string | undefined, data: object) => {
    const resposta = await api.post(
      `rifa/${slug}/exibe-premios-roleta-rifa`,
      data
    );
    return resposta.data;
  },
});
